import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";

import App from "./App";
import "./styles/global.css";
import "./styles/docking-theme.css";

// -- AG Grid module registration (required since v35) --
ModuleRegistry.registerModules([AllCommunityModule, AllEnterpriseModule]);

// -- AG Grid Enterprise license --
const agLicenseKey = import.meta.env.VITE_AG_GRID_LICENSE_KEY;
if (agLicenseKey) {
  LicenseManager.setLicenseKey(agLicenseKey);
}

// Vite sets BASE_URL from the `base` config (e.g. "/thread/" in production, "/" in dev).
// Strip trailing slash for BrowserRouter basename (it expects "/thread" not "/thread/").
const basename = import.meta.env.BASE_URL.replace(/\/$/, "") || "/";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
